export interface Solution {
  title: string;
  description: string;
  moreInfoLink?: string;
}

export type SubsolutionRecord = Record<string, Solution>;

export enum GesellschaftsrechtSolutionEnum {
  GesellschafterstreitLoesen = "GesellschafterstreitLoesen",
  OrganhaftungGeltendmachen = "OrganhaftungGeltendmachen",
  MitarbeiterBeteiligen = "MitarbeiterBeteiligen",
  GremienBeraten = "GremienBeraten",
  MAndA = "MAndA",
  SteueroptimiertGestalten = "SteueroptimiertGestalten",
}

export enum HoldingSolutionEnum {
  HoldingstrukturGründen = "HoldingstrukturGründen",
  AnteilstauschBegleiten = "AnteilstauschBegleiten",
  HoldingNachträglichZwischenschalten = "HoldingNachträglichZwischenschalten",
}
